"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainShellContainerComponent = void 0;
const React = __importStar(require("react"));
const UserProfile = __importStar(require("@genesys/client-core/lib/user-profile"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const GlobalActions = __importStar(require("@genesys/client-core/lib/global-actions"));
const StickyMenu = __importStar(require("../sticky-menu/index"));
const Actions = __importStar(require("./actions"));
const MainContent = __importStar(require("../main-content/index"));
const error_dialog_1 = require("./../error-dialog/");
const Authorization = __importStar(require("@genesys/shared/lib/authorization"));
class MainShellContainerComponent extends React.Component {
    // biome-ignore lint: -
    constructor(props) {
        super(props);
    }
    componentDidCatch(error, errorInfo) {
        console.log(errorInfo);
        this.props.dispatch(GlobalActions.error({
            referenceNo: "",
            invalidState: true,
            message: error.message,
            exception: error.stack
        }));
    }
    render() {
        return (React.createElement(Contexts.TranslateContext.Consumer, null, translate => (React.createElement(UserProfile.UserProfile, null, ({ currency, language, locale, userName, applicationClaims }) => {
            const { dispatch, exceptionReport, errorDialog } = this.props;
            const toggleErrorDetails = () => dispatch(Actions.toggleErrorDetails());
            if (exceptionReport) {
                return (React.createElement(error_dialog_1.ErrorDialogComponent, { exceptionReport: exceptionReport, showDetails: errorDialog.showDetails, toggleErrorDetails: toggleErrorDetails, textTranslator: translate }));
            }
            if (!language ||
                !locale ||
                !currency ||
                !userSettingsDoComplyWithClaims(applicationClaims, currency)) {
                return React.createElement("div", null, "Missing User settings");
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(StickyMenu.Container, { userName: userName }),
                React.createElement(MainContent.Container, null)));
        }))));
    }
}
exports.MainShellContainerComponent = MainShellContainerComponent;
function userSettingsDoComplyWithClaims(claims, currency) {
    if (!Authorization.hasPermission(claims, "CurrencyPrice", currency)) {
        return false;
    }
    return true;
}
//# sourceMappingURL=container-component.js.map